import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not configured')
}

export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      // Detect session from URL only on the callback page
      detectSessionInUrl: window.location.pathname === '/auth/callback',
      // Persist session to localStorage
      persistSession: true,
      // Automatically refresh the token before it expires
      autoRefreshToken: true,
    },
  }
)
